import { createSlice } from '@reduxjs/toolkit';

// project imports
import rackAxiosServices from 'utils/rackAxiosServices';

import { dispatch } from '../index';

const initialState = {
  error: null,
  grower: {
    groweruuid: '',
    agronomistuuid: '',
    growerGeneralInfo: {},
    equipmentInformation: {},
    seedInfo: {},
    yieldInfo: {},
    scoutTestInfo: {},
    cropPlannerInfo: [],
    cropPlannerAnalysis: [],
    loadingCropPlanner: false,
    impactFilters: [],
    loadingGrower: false,
  },
  growers: [],
  loadingAllGrowers: false,
};

const grower = createSlice({
  name: 'grower',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload.error;
    },
    //Clear current grower from state, since we are working on a new grower
    clearCurrentGrowerData(state, action) {
      state.grower.growerGeneralInfo = undefined;
      state.grower.groweruuid = undefined;
      state.grower.equipmentInformation = undefined;
      state.grower.seedInfo = undefined;
      state.grower.yieldInfo = undefined;
      state.grower.scoutTestInfo = undefined;
      state.grower.cropPlannerInfo = undefined;
      state.grower.impactFilters = undefined;
      state.grower.cropPlannerAnalysis = undefined;
    },
    clearCurrentCropPlannerAnalysis(state,action) {
      state.grower.cropPlannerAnalysis = undefined;

    },

    // UPDATE Grower creater field
    updateGrowerCreatorSuccess(state, action) {
      state.grower.agronomistuuid = action.payload.agronomistuuid;
      state.grower.groweruuid = action.payload.groweruuid;
      state.grower.createdBy = action.payload.createdBy;
    },
    // ADD General Information
    addGeneralInformationSuccess(state, action) {
      state.grower.growerGeneralInfo = action.payload.growerGeneralInfo;
      state.grower.agronomistuuid = action.payload.agronomistuuid;
      state.grower.groweruuid = action.payload.groweruuid;
    },
    // UPDATE General Information
    updateGeneralInformationSuccess(state, action) {
      state.grower.growerGeneralInfo = action.payload.updateInformation;
      state.grower.agronomistuuid = action.payload.agronomistuuid;
      state.grower.groweruuid = action.payload.groweruuid;
    },
    // ADD Equip Information
    addEquipmentInformationSuccess(state, action) {
      state.grower.equipmentInformation = action.payload.equipmentInformation;
    },
    // UPDATE Equip Information
    updateEquipmentInformationSuccess(state, action) {
      state.grower.equipmentInformation = action.payload.updateInformation;
    },
    // ADD Seeding Information
    addSeedingInformationSuccess(state, action) {
      state.grower.seedInfo = action.payload.seedInfo;
    },
    // UPDATE Seeding Information
    updateSeedingInformationSuccess(state, action) {
      state.grower.seedInfo = action.payload.updateInformation;
    },
    // ADD Yield Information
    addYieldInformationSuccess(state, action) {
      state.grower.yieldInfo = action.payload.yieldInfo;
    },
    // UPDATE Yield Information
    updateYieldInformationSuccess(state, action) {
      state.grower.yieldInfo = action.payload.updateInformation;
    },
    // ADD Scout Test Information
    addScoutTestInformationSuccess(state, action) {
      state.grower.scoutTestInfo = action.payload.scoutTestInfo;
    },
    // UPDATE Scout Test Information
    updateScoutTestInformationSuccess(state, action) {
      state.grower.scoutTestInfo = action.payload.updateInformation;
    },
    // ADD Crop Planner Information
    addCropPlannerInformationSuccess(state, action) {
      state.grower.cropPlannerInfo = action.payload.cropPlannerInfo;
    },
    // UPDATE Crop Planner Information
    updateCropPlannerInformationSuccess(state, action) {
      state.grower.cropPlannerInfo = action.payload.updateInformation;
    },
    // ADD Impact Filter
    addImpactFilterInformationSuccess(state, action) {
      state.grower.impactFilters = action.payload.impactFilters;
    },
    // UPDATE Impact Filter
    updateImpactFilterInformationSuccess(state, action) {
      state.grower.impactFilters = action.payload.updateInformation;
    },
    // GET All Growers
    getGrowersSuccess(state, action) {
      state.growers = action.payload;
      state.error = null;
    },

    getGrowerSuccess(state, action) {
      state.grower = action.payload
      state.error = null;
    },
    getCropPlannerAnalysisSuccess(state, action){
      state.grower.cropPlannerAnalysis = action.payload;
    },
    setCropPlannerLoading(state, action){
      state.grower.loadingCropPlanner = action.payload;
    },
    setGrowerLoading(state, action){
      state.grower.loadingGrower = action.payload;
    },
    setAllGrowersLoading(state, action){
      state.loadingAllGrowers = action.payload;
    },
  }
});

// Reducer
export default grower.reducer;
//Export action for dispatch usage
export const { clearCurrentGrowerData, clearCurrentCropPlannerAnalysis } = grower.actions;

export function getGrower(growerUuid) {
  return async () => {
    try {
      dispatch(grower.actions.setGrowerLoading(true));
      const url = process.env.REACT_APP_GROWER_API_URL + '/' + growerUuid;
      const response = await rackAxiosServices.get(url);
      dispatch(grower.actions.getGrowerSuccess(response.data[0]));
      dispatch(grower.actions.setGrowerLoading(false));

    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
      console.log("grower get err", axiosError);
    }
  };
}

export function getGrowersByAgronomist(agronomistUUID) {
  return async () => {
    try {
      dispatch(grower.actions.setAllGrowersLoading(true));

      const url = process.env.REACT_APP_GROWER_API_URL + '/agronomist/' + agronomistUUID;
      const response = await rackAxiosServices.get(url);
      dispatch(grower.actions.getGrowersSuccess(response.data));
      dispatch(grower.actions.setAllGrowersLoading(false));
    } catch (error) {
      console.log(`Error from axios call ${JSON.stringify(error)}`);
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function getGrowersByAgronomistTeams(agronomistUUID) {
  return async () => {
    try {
      dispatch(grower.actions.setAllGrowersLoading(true));
      const url = process.env.REACT_APP_GROWER_API_URL + '/agronomist/team/' + agronomistUUID;
      const response = await rackAxiosServices.get(url);
      dispatch(grower.actions.getGrowersSuccess(response.data));
      dispatch(grower.actions.setAllGrowersLoading(false));
    } catch (error) {
      console.log(`Error from axios call ${JSON.stringify(error)}`);
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function deleteGrower(grower) {


  return async () => {
    try {
      console.log('calling delete grower', grower);
      const url = process.env.REACT_APP_GROWER_API_URL + '/object/' + grower.groweruuid;
      const response = await rackAxiosServices.delete(url);
      
    } catch (error) {
      console.log("error delete grower", error.response.data);
      dispatch(grower.actions.hasError(error.response.data));
    }
  };
}


export function adminGetAllGrowers() {
  return async () => {
    try {
      dispatch(grower.actions.setAllGrowersLoading(true));
      const url = process.env.REACT_APP_GROWER_API_URL;
      const response = await rackAxiosServices.get(url);
      dispatch(grower.actions.getGrowersSuccess(response.data));
      dispatch(grower.actions.setAllGrowersLoading(false));
    } catch (error) {
      console.log(`Error from axios call ${JSON.stringify(error)}`);
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function saveGrowerGeneralInformation(generalInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL, { ...generalInfo });
      dispatch(grower.actions.addGeneralInformationSuccess(generalInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function saveGrowerEquipmentInformation(equipmentInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...equipmentInfo });
      dispatch(grower.actions.addEquipmentInformationSuccess(equipmentInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function saveGrowerSeedingInformation(seedInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...seedInfo });
      dispatch(grower.actions.addSeedingInformationSuccess(seedInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function saveGrowerYieldInformation(yieldInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...yieldInfo });
      dispatch(grower.actions.addYieldInformationSuccess(yieldInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function saveGrowerScoutTestInformation(scoutTestInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...scoutTestInfo });
      dispatch(grower.actions.addScoutTestInformationSuccess(scoutTestInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

//Only use this api call if you need to update the top level data for a grower, which for now will only be to update the 'createdBy' field
export function updateGrower(info) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/updateGrowerCreater', { ...info });
      dispatch(grower.actions.updateGrowerCreatorSuccess(info));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function updateGrowerGeneralInformation(generalInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...generalInfo });
      console.log("general info", generalInfo);
      dispatch(grower.actions.updateGeneralInformationSuccess(generalInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
      console.log("response error", axiosError);
      console.log("response error", error.response);
    }
  };
}

export function updateGrowerEquipmentInformation(equipmentInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...equipmentInfo });
      dispatch(grower.actions.updateEquipmentInformationSuccess(equipmentInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function updateGrowerSeedingInformation(seedInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...seedInfo });
      dispatch(grower.actions.updateSeedingInformationSuccess(seedInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function updateGrowerYieldInformation(yieldInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...yieldInfo });
      dispatch(grower.actions.updateYieldInformationSuccess(yieldInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function updateGrowerScoutTestInformation(scoutTestInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...scoutTestInfo });
      dispatch(grower.actions.updateScoutTestInformationSuccess(scoutTestInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
    }
  };
}

export function saveGrowerCropPlanner(cropPlannerInfo) {
  return async () => {
    try {
      dispatch(grower.actions.setCropPlannerLoading(true));
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...cropPlannerInfo });
      dispatch(grower.actions.addCropPlannerInformationSuccess(cropPlannerInfo));
      dispatch(grower.actions.setCropPlannerLoading(false));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
      console.log("response error", error.response);
    }
  };
}

export function updateCropPlannerInformation(cropPlannerInfo) {
  return async () => {
    try {
      dispatch(grower.actions.setCropPlannerLoading(false));
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...cropPlannerInfo });
      dispatch(grower.actions.updateCropPlannerInformationSuccess(cropPlannerInfo));
      dispatch(grower.actions.setCropPlannerLoading(false));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
      console.log("response error", axiosError);
    }
  };
}


export function saveGrowerImpactFilter(impactFilterInfo) {

  console.log('impact info', impactFilterInfo)
  return async () => {
    try {
      dispatch(grower.actions.setGrowerLoading(true));
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...impactFilterInfo });
      dispatch(grower.actions.addImpactFilterInformationSuccess(impactFilterInfo));
      dispatch(grower.actions.setGrowerLoading(false));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
      console.log("response error", axiosError);
    }
  };
}

export function updateImpactFilterInformation(impactFilterInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_GROWER_API_URL + '/update', { ...impactFilterInfo });
      dispatch(grower.actions.updateImpactFilterInformationSuccess(impactFilterInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
      console.log("response error", axiosError);
    }
  };
}

export function getCropPlannerAnalysis(cropPlannerData) {
 

  return async () => {
    try {
      dispatch(grower.actions.setCropPlannerLoading(true));
      const response = await rackAxiosServices.post(process.env.REACT_APP_BUS_LOGIC_URL + '/crop-planner', cropPlannerData);
      dispatch(grower.actions.getCropPlannerAnalysisSuccess(response.data));
      dispatch(grower.actions.setCropPlannerLoading(false));

    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower.actions.hasError(axiosError));
      console.log("response error", error);
    }
  };
}

